<p-button
  id="additionalImbActionsBtn"
  (click)="accountAdditionalActionsMenu.toggle($event)"
  icon="pi pi-download"
  class="ml-2 inline-block"
  [rounded]="true"
  [outlined]="true"
  [disabled]="disableExport"
  data-testid="agility-export-button"
></p-button>
<p-menu
  #accountAdditionalActionsMenu
  [model]="additionalActions"
  id="accountAdditionalActionsMenu"
  styleClass="mt-2"
  appendTo="body"
  [popup]="true"
  data-testid="agility-export-menu"
></p-menu>
